import { logEvent, type Analytics } from "firebase/analytics";
import { getAnalytics, isSupported } from "firebase/analytics";
import { app } from "./firebase";

let _analytics: Analytics | null = null;
let _initPromise: Promise<Analytics | null> | null = null;

async function getAnalyticsLazy(): Promise<Analytics | null> {
  if (_analytics) return _analytics;
  if (_initPromise) return _initPromise;
  _initPromise = (async () => {
    const ok = await isSupported();
    if (!ok) return null;
    _analytics = getAnalytics(app);
    return _analytics;
  })();
  return _initPromise;
}

/**
 * Track de eventos custom para GA4. Nunca lanza errores; si Analytics no está
 * disponible (incognito, adblock, SSR) simplemente no hace nada.
 *
 * Convenciones de nombres: snake_case, evento_pasado.
 *   - signup_started
 *   - signup_step_completed (con paso)
 *   - signup_completed (con tenantId, refSource, businessType)
 *   - qr_downloaded
 *   - qr_shared
 *   - tenant_joined (cliente vía QR)
 *   - login_attempted
 *   - anonymous_upgraded
 */
export function track(eventName: string, params?: Record<string, unknown>): void {
  getAnalyticsLazy()
    .then((a) => {
      if (a) logEvent(a, eventName as never, params as never);
    })
    .catch(() => {
      /* silencioso */
    });
}

/** Marca propiedades del usuario en GA4 (vista de cohorts). */
export async function setUserAnalyticsProperties(props: Record<string, string>): Promise<void> {
  const a = await getAnalyticsLazy();
  if (!a) return;
  const { setUserProperties } = await import("firebase/analytics");
  setUserProperties(a, props);
}
